export default __webpack_public_path__ + "static/cafefloor-fb541135f16640d96f23f450b13aaefb.png";